// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 2 2%27%3E%3Cpath fill=%27rgba%281.0,1.0,1.0,0.3%29%27 fill-rule=%27evenodd%27 d=%27M0 0h1v1H0V0zm1 1h1v1H1V1z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#inspector-host {
  position: absolute;
  right: 0px;
  top: 0px;
  bottom: 0px;
}

#__resizable_base__ {
  display: none;
}

#actionTabs {
  background: #333333;
  height: 100%;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-rows: auto 1fr;
  font: 14px "Arial";
  overflow: hidden;
}
#actionTabs .hoverIcon:hover {
  opacity: 0.8;
}
#actionTabs #header {
  height: 30px;
  font-size: 16px;
  color: white;
  background: #222222;
  grid-row: 1;
  text-align: center;
  display: grid;
  grid-template-columns: 30px 1fr 50px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
#actionTabs #header #logo {
  grid-column: 1;
  width: 24px;
  height: 24px;
  display: flex;
  align-self: center;
  justify-self: center;
}
#actionTabs #header #back {
  grid-column: 1;
  display: grid;
  align-self: center;
  justify-self: center;
  cursor: pointer;
}
#actionTabs #header #title {
  grid-column: 2;
  display: grid;
  align-items: center;
  text-align: center;
}
#actionTabs #header #commands {
  grid-column: 3;
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
}
#actionTabs #header #commands .expand {
  grid-column: 1;
  display: grid;
  align-items: center;
  justify-items: center;
  cursor: pointer;
}
#actionTabs #header #commands .close {
  grid-column: 2;
  display: grid;
  align-items: center;
  justify-items: center;
  cursor: pointer;
}
#actionTabs .tabsMenu {
  display: grid;
  grid-row: 2;
  grid-template-rows: 40px 1fr;
  font: 14px "Arial";
  overflow: hidden;
}
#actionTabs .tabsMenu .labels {
  grid-row: 1;
  display: flex;
  align-items: center;
  justify-items: center;
  border-bottom: 1px solid #ffffff;
  margin: 0;
  padding: 0;
}
#actionTabs .tabsMenu .labels .label {
  font-size: 24px;
  color: white;
  width: 40px;
  display: flex;
  align-content: center;
  justify-content: center;
  border: 1px solid transparent;
  border-bottom: none;
  background: #333333;
  padding: 5px;
  height: 28px;
  cursor: pointer;
}
#actionTabs .tabsMenu .labels .label.active {
  border-color: #ffffff;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
}
#actionTabs .tabsMenu .panes {
  grid-row: 2;
  display: grid;
  grid-template-rows: 100%;
  overflow: hidden;
}
#actionTabs .tabsMenu .panes .infoMessage {
  opacity: 0.5;
  color: white;
  margin: 15px 5px 0px 5px;
}
#actionTabs .tabsMenu .panes .gradient-step {
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: 20px 30px 40px auto 20px 30px;
  padding-top: 5px;
  padding-left: 5px;
  padding-bottom: 5px;
  align-items: center;
}
#actionTabs .tabsMenu .panes .gradient-step .step {
  grid-row: 1;
  grid-column: 1;
}
#actionTabs .tabsMenu .panes .gradient-step .color1 {
  height: 100%;
}
#actionTabs .tabsMenu .panes .gradient-step .color2 {
  height: 100%;
  padding-left: 5px;
}
#actionTabs .tabsMenu .panes .gradient-step .factor1 {
  grid-row: 1;
  grid-column: 2;
  cursor: pointer;
}
#actionTabs .tabsMenu .panes .gradient-step .factor2 {
  padding-left: 5px;
  grid-row: 1;
  grid-column: 3;
  cursor: pointer;
}
#actionTabs .tabsMenu .panes .gradient-step .factor2 .grayed {
  background: gray;
  border-color: gray;
}
#actionTabs .tabsMenu .panes .gradient-step .numeric-input {
  width: calc(100% - 5px);
}
#actionTabs .tabsMenu .panes .gradient-step .icon {
  cursor: pointer;
}
#actionTabs .tabsMenu .panes .gradient-step .step-value {
  margin-left: 5px;
  grid-row: 1;
  grid-column: 3;
  text-align: right;
  margin-right: 5px;
}
#actionTabs .tabsMenu .panes .gradient-step .step-slider {
  grid-row: 1;
  grid-column: 4;
  display: grid;
  justify-content: stretch;
  align-content: center;
  margin-right: 12px;
}
#actionTabs .tabsMenu .panes .gradient-step .step-slider input {
  width: 100%;
}
#actionTabs .tabsMenu .panes .gradient-step .step-slider .range:hover {
  opacity: 1;
}
#actionTabs .tabsMenu .panes .gradient-step .step-slider .range {
  -webkit-appearance: none;
  height: 6px;
  background: #d3d3d3;
  border-radius: 5px;
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
}
#actionTabs .tabsMenu .panes .gradient-step .step-slider .range::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: rgb(51, 122, 183);
  cursor: pointer;
}
#actionTabs .tabsMenu .panes .gradient-step .step-slider .range::-moz-range-thumb {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: rgb(51, 122, 183);
  cursor: pointer;
}
#actionTabs .tabsMenu .panes .gradient-step .gradient-copy {
  grid-row: 1;
  grid-column: 5;
  display: grid;
  align-content: center;
  justify-content: center;
}
#actionTabs .tabsMenu .panes .gradient-step .gradient-copy .img {
  height: 20px;
  width: 20px;
}
#actionTabs .tabsMenu .panes .gradient-step .gradient-copy .img:hover {
  cursor: pointer;
}
#actionTabs .tabsMenu .panes .gradient-step .gradient-delete {
  grid-row: 1;
  grid-column: 6;
  display: grid;
  align-content: center;
  justify-content: center;
}
#actionTabs .tabsMenu .panes .gradient-step .gradient-delete .img {
  height: 20px;
  width: 20px;
}
#actionTabs .tabsMenu .panes .gradient-step .gradient-delete .img:hover {
  cursor: pointer;
}
#actionTabs .tabsMenu .panes .pane {
  color: white;
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
#actionTabs .tabsMenu .panes .pane .animation-info {
  border-left: greenyellow 3px solid;
  margin-left: 5px;
  padding-left: 5px !important;
}
#actionTabs .tabsMenu .panes .pane .underline {
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.5);
}
#actionTabs .tabsMenu .panes .pane .textureLinkLine {
  display: grid;
  grid-template-columns: auto 1fr;
}
#actionTabs .tabsMenu .panes .pane .textureLinkLine .debug {
  grid-column: 1;
  margin-left: 5px;
  margin-right: 5px;
  display: block;
  align-items: center;
  justify-items: center;
  cursor: pointer;
  opacity: 0.5;
}
#actionTabs .tabsMenu .panes .pane .textureLinkLine .debug.selected {
  opacity: 1;
}
#actionTabs .tabsMenu .panes .pane .textureLinkLine .textLine {
  grid-column: 2;
}
#actionTabs .tabsMenu .panes .pane .textureLinkLine .actionIcon {
  display: inline-block;
  margin-top: 6px;
  margin-right: 4px;
}
#actionTabs .tabsMenu .panes .pane .messageLine {
  text-align: center;
  font-size: 12px;
  font-style: italic;
  opacity: 0.6;
}
#actionTabs .tabsMenu .panes .pane .iconMessageLine {
  padding-left: 2px;
  height: 30px;
  display: grid;
  grid-template-columns: 30px 1fr;
}
#actionTabs .tabsMenu .panes .pane .iconMessageLine .icon {
  grid-column: 1;
  display: grid;
  align-items: center;
  justify-items: center;
}
#actionTabs .tabsMenu .panes .pane .iconMessageLine .value {
  grid-column: 2;
  display: flex;
  align-items: center;
}
#actionTabs .tabsMenu .panes .pane .color-picker {
  height: calc(100% - 8px);
  margin: 4px;
  width: 100%;
}
#actionTabs .tabsMenu .panes .pane .color-picker .color-rect {
  height: calc(100% - 4px);
  border: 2px white solid;
  cursor: pointer;
  min-height: 18px;
}
#actionTabs .tabsMenu .panes .pane .color-picker .color-picker-cover {
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: 100;
}
#actionTabs .tabsMenu .panes .pane .color-picker .color-picker-float {
  position: absolute;
}
#actionTabs .tabsMenu .panes .pane .linkButtonLine {
  padding-left: 2px;
  height: 30px;
  display: grid;
  grid-template-columns: 1fr auto 20px;
}
#actionTabs .tabsMenu .panes .pane .linkButtonLine .link {
  grid-column: 1;
  display: flex;
  align-items: center;
  text-decoration: underline;
  cursor: pointer;
}
#actionTabs .tabsMenu .panes .pane .linkButtonLine .link-button {
  grid-column: 2;
}
#actionTabs .tabsMenu .panes .pane .linkButtonLine .link-button button {
  background: #222222;
  border: 1px solid rgb(51, 122, 183);
  margin: 5px 10px 5px 10px;
  color: white;
  padding: 4px 5px;
  opacity: 0.9;
  cursor: pointer;
}
#actionTabs .tabsMenu .panes .pane .linkButtonLine .link-button button:hover {
  opacity: 1;
}
#actionTabs .tabsMenu .panes .pane .linkButtonLine .link-button button:active {
  background: #282828;
}
#actionTabs .tabsMenu .panes .pane .linkButtonLine .link-button button:focus {
  border: 1px solid rgb(51, 122, 183);
  outline: 0px;
}
#actionTabs .tabsMenu .panes .pane .linkButtonLine .link-icon {
  grid-column: 3;
  display: grid;
  align-content: center;
}
#actionTabs .tabsMenu .panes .pane .textLine {
  padding-left: 2px;
  height: 30px;
  display: grid;
  grid-template-columns: 1fr auto;
}
#actionTabs .tabsMenu .panes .pane .textLine.indented {
  grid-template-columns: 100%;
}
#actionTabs .tabsMenu .panes .pane .textLine.indented .link-value {
  grid-column: 1;
  text-align: start;
  margin-left: 20px;
  opacity: 0.6;
  max-width: unset;
}
#actionTabs .tabsMenu .panes .pane .textLine.indented .value {
  grid-column: 1;
  text-align: start;
  margin-left: 20px;
  opacity: 0.6;
  max-width: unset;
}
#actionTabs .tabsMenu .panes .pane .textLine.reduced-opacity {
  opacity: 0.6;
  padding-left: 25px;
}
#actionTabs .tabsMenu .panes .pane .textLine .label {
  grid-column: 1;
  display: flex;
  align-items: center;
}
#actionTabs .tabsMenu .panes .pane .textLine .link-value {
  grid-column: 2;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: end;
  opacity: 0.8;
  margin: 5px;
  margin-top: 7px;
  max-width: 140px;
  text-decoration: underline;
  cursor: pointer;
}
#actionTabs .tabsMenu .panes .pane .textLine .value {
  grid-column: 2;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: end;
  opacity: 0.8;
  margin: 5px;
  margin-top: 7px;
  max-width: 200px;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
#actionTabs .tabsMenu .panes .pane .textLine .value.check {
  color: green;
}
#actionTabs .tabsMenu .panes .pane .textLine .value.uncheck {
  color: red;
}
#actionTabs .tabsMenu .panes .pane .gradient-container {
  margin-top: 3px;
}
#actionTabs .tabsMenu .panes .pane .gradient-container .gradient-label {
  height: 30px;
  display: grid;
  align-content: center;
}
#actionTabs .tabsMenu .panes .pane .gradient-container .gradient-step {
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: 25px 50px 55px 40px auto 20px 5px;
  padding-top: 5px;
  padding-left: 5px;
  padding-bottom: 5px;
  align-items: center;
  border-left: orange 3px solid;
}
#actionTabs .tabsMenu .panes .pane .gradient-container .gradient-step .step {
  grid-row: 1;
  grid-column: 1;
}
#actionTabs .tabsMenu .panes .pane .gradient-container .gradient-step .color1 {
  height: 100%;
}
#actionTabs .tabsMenu .panes .pane .gradient-container .gradient-step .color2 {
  height: 100%;
  padding-left: 5px;
}
#actionTabs .tabsMenu .panes .pane .gradient-container .gradient-step .factor1 {
  grid-row: 1;
  grid-column: 2;
  cursor: pointer;
}
#actionTabs .tabsMenu .panes .pane .gradient-container .gradient-step .factor2 {
  padding-left: 5px;
  grid-row: 1;
  grid-column: 3;
  cursor: pointer;
}
#actionTabs .tabsMenu .panes .pane .gradient-container .gradient-step .factor2 .grayed {
  background: gray;
  border-color: gray;
}
#actionTabs .tabsMenu .panes .pane .gradient-container .gradient-step .numeric-input {
  width: calc(100% - 5px);
}
#actionTabs .tabsMenu .panes .pane .gradient-container .gradient-step .step-value {
  margin-left: 5px;
  grid-row: 1;
  grid-column: 4;
  text-align: right;
  margin-right: 5px;
}
#actionTabs .tabsMenu .panes .pane .gradient-container .gradient-step .step-slider {
  grid-row: 1;
  grid-column: 5;
  display: grid;
  justify-content: stretch;
  align-content: center;
  margin-right: 5px;
}
#actionTabs .tabsMenu .panes .pane .gradient-container .gradient-step .step-slider input {
  width: 100%;
}
#actionTabs .tabsMenu .panes .pane .gradient-container .gradient-step .gradient-delete {
  grid-row: 1;
  grid-column: 6;
  display: grid;
  align-content: center;
  justify-content: center;
}
#actionTabs .tabsMenu .panes .pane .textInputLine {
  padding-left: 2px;
  height: 30px;
  display: grid;
  grid-template-columns: 1fr 120px;
}
#actionTabs .tabsMenu .panes .pane .textInputLine .label {
  grid-column: 1;
  display: flex;
  align-items: center;
}
#actionTabs .tabsMenu .panes .pane .textInputLine .value {
  display: flex;
  align-items: center;
  grid-column: 2;
}
#actionTabs .tabsMenu .panes .pane .textInputLine .value input {
  width: 110px;
}
#actionTabs .tabsMenu .panes .pane .buttonLine {
  height: 30px;
  display: grid;
  align-items: center;
  justify-items: stretch;
}
#actionTabs .tabsMenu .panes .pane .buttonLine input[type=file] {
  display: none;
}
#actionTabs .tabsMenu .panes .pane .buttonLine .file-upload {
  background: #222222;
  border: 1px solid rgb(51, 122, 183);
  margin: 5px 10px 5px 10px;
  color: white;
  padding: 4px 5px;
  font-size: 13px;
  opacity: 0.9;
  cursor: pointer;
  text-align: center;
}
#actionTabs .tabsMenu .panes .pane .buttonLine .file-upload:hover {
  opacity: 1;
}
#actionTabs .tabsMenu .panes .pane .buttonLine .file-upload:active {
  transform: scale(0.98);
  transform-origin: 0.5 0.5;
}
#actionTabs .tabsMenu .panes .pane .buttonLine button {
  background: #222222;
  border: 1px solid rgb(51, 122, 183);
  margin: 5px 10px 5px 10px;
  color: white;
  padding: 4px 5px;
  opacity: 0.9;
  cursor: pointer;
}
#actionTabs .tabsMenu .panes .pane .buttonLine button:hover {
  opacity: 1;
}
#actionTabs .tabsMenu .panes .pane .buttonLine button:active {
  background: #282828;
}
#actionTabs .tabsMenu .panes .pane .buttonLine button:focus {
  border: 1px solid rgb(51, 122, 183);
  outline: 0px;
}
#actionTabs .tabsMenu .panes .pane .radioLine {
  padding-left: 2px;
  height: 30px;
  display: grid;
  grid-template-columns: 1fr 24px;
}
#actionTabs .tabsMenu .panes .pane .radioLine .label {
  grid-column: 1;
  display: flex;
  align-items: center;
}
#actionTabs .tabsMenu .panes .pane .radioLine .radioContainer {
  display: flex;
  align-items: center;
}
#actionTabs .tabsMenu .panes .pane .radioLine .radioContainer .radio {
  grid-column: 2;
  display: none;
}
#actionTabs .tabsMenu .panes .pane .radioLine .radioContainer .radio:checked + label:before {
  border-color: rgb(51, 122, 183);
}
#actionTabs .tabsMenu .panes .pane .radioLine .radioContainer .radio:checked + label:after {
  transform: scale(1);
}
#actionTabs .tabsMenu .panes .pane .radioLine .radioContainer .labelForRadio {
  display: inline-block;
  height: 14px;
  position: relative;
  padding: 0 24px;
  margin-bottom: 0;
  cursor: pointer;
  vertical-align: bottom;
}
#actionTabs .tabsMenu .panes .pane .radioLine .radioContainer .labelForRadio:before, #actionTabs .tabsMenu .panes .pane .radioLine .radioContainer .labelForRadio:after {
  position: absolute;
  content: "";
  border-radius: 50%;
  transition: all 0.3s ease;
  transition-property: transform, border-color;
}
#actionTabs .tabsMenu .panes .pane .radioLine .radioContainer .labelForRadio:before {
  left: 0px;
  top: 0;
  width: 16px;
  height: 16px;
  border: 2px solid white;
}
#actionTabs .tabsMenu .panes .pane .radioLine .radioContainer .labelForRadio:after {
  top: 6px;
  left: 6px;
  width: 8px;
  height: 8px;
  transform: scale(0);
  background: rgb(51, 122, 183);
}
#actionTabs .tabsMenu .panes .pane .vector3Line {
  padding-left: 2px;
  display: grid;
}
#actionTabs .tabsMenu .panes .pane .vector3Line .firstLine {
  display: grid;
  grid-template-columns: 1fr auto 20px;
  height: 30px;
}
#actionTabs .tabsMenu .panes .pane .vector3Line .firstLine .label {
  grid-column: 1;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
}
#actionTabs .tabsMenu .panes .pane .vector3Line .firstLine .vector {
  grid-column: 2;
  display: flex;
  align-items: center;
  text-align: right;
  opacity: 0.8;
  padding-left: 5px;
}
#actionTabs .tabsMenu .panes .pane .vector3Line .firstLine .expand {
  grid-column: 3;
  display: grid;
  align-items: center;
  justify-items: center;
  cursor: pointer;
}
#actionTabs .tabsMenu .panes .pane .vector3Line .secondLine {
  display: grid;
  padding-right: 5px;
  border-left: 1px solid rgb(51, 122, 183);
}
#actionTabs .tabsMenu .panes .pane .vector3Line .secondLine .numeric {
  display: grid;
  grid-template-columns: 1fr auto;
}
#actionTabs .tabsMenu .panes .pane .vector3Line .secondLine .numeric-label {
  text-align: right;
  grid-column: 1;
  display: flex;
  align-items: center;
  justify-self: right;
  margin-right: 10px;
}
#actionTabs .tabsMenu .panes .pane .vector3Line .secondLine .numeric-value {
  width: 120px;
  grid-column: 2;
  display: flex;
  align-items: center;
  border: 1px solid rgb(51, 122, 183);
}
#actionTabs .tabsMenu .panes .pane .checkBoxLine {
  padding-left: 2px;
  height: 30px;
  display: grid;
  grid-template-columns: 1fr auto;
}
#actionTabs .tabsMenu .panes .pane .checkBoxLine .label {
  grid-column: 1;
  display: flex;
  align-items: center;
}
#actionTabs .tabsMenu .panes .pane .checkBoxLine .checkBox {
  grid-column: 2;
  display: flex;
  align-items: center;
}
#actionTabs .tabsMenu .panes .pane .checkBoxLine .checkBox .lbl {
  position: relative;
  display: block;
  height: 14px;
  width: 34px;
  margin-right: 5px;
  background: #898989;
  border-radius: 100px;
  cursor: pointer;
  transition: all 0.3s ease;
}
#actionTabs .tabsMenu .panes .pane .checkBoxLine .checkBox .lbl.checked {
  background: rgb(51, 122, 183);
}
#actionTabs .tabsMenu .panes .pane .checkBoxLine .checkBox .lbl:after {
  position: absolute;
  left: 3px;
  top: 2px;
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 100px;
  background: #fff;
  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.05);
  content: "";
  transition: all 0.15s ease;
}
#actionTabs .tabsMenu .panes .pane .checkBoxLine .checkBox .lbl:after.checked {
  left: 20px;
  background: rgb(22, 73, 117);
}
#actionTabs .tabsMenu .panes .pane .checkBoxLine .checkBox .lbl.checked:after {
  position: absolute;
  top: 2px;
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 100px;
  background: #fff;
  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.05);
  content: "";
  transition: all 0.15s ease;
  left: 20px;
  background: rgb(22, 73, 117);
}
#actionTabs .tabsMenu .panes .pane .checkBoxLine .checkBox .lbl:active:after {
  transform: scale(1.15, 0.85);
}
#actionTabs .tabsMenu .panes .pane .checkBoxLine .checkBox .hidden {
  display: none;
}
#actionTabs .tabsMenu .panes .pane .checkBoxLine .checkBox .icon {
  display: none;
}
#actionTabs .tabsMenu .panes .pane .textureLine {
  display: grid;
  grid-template-rows: 30px auto;
}
#actionTabs .tabsMenu .panes .pane .textureLine .control {
  margin-top: 2px;
  grid-row: 1;
  display: grid;
  grid-template-columns: 1fr 40px 40px 40px 40px 40px 1fr;
}
#actionTabs .tabsMenu .panes .pane .textureLine .control .red {
  grid-column: 2;
}
#actionTabs .tabsMenu .panes .pane .textureLine .control .green {
  grid-column: 3;
}
#actionTabs .tabsMenu .panes .pane .textureLine .control .blue {
  grid-column: 4;
}
#actionTabs .tabsMenu .panes .pane .textureLine .control .alpha {
  grid-column: 5;
}
#actionTabs .tabsMenu .panes .pane .textureLine .control .all {
  grid-column: 6;
}
#actionTabs .tabsMenu .panes .pane .textureLine .control3D {
  margin-top: 2px;
  grid-row: 1;
  display: grid;
  grid-template-columns: 1fr 40px 40px 40px 40px 40px 40px 1fr;
}
#actionTabs .tabsMenu .panes .pane .textureLine .control3D .px {
  grid-column: 2;
}
#actionTabs .tabsMenu .panes .pane .textureLine .control3D .nx {
  grid-column: 3;
}
#actionTabs .tabsMenu .panes .pane .textureLine .control3D .py {
  grid-column: 4;
}
#actionTabs .tabsMenu .panes .pane .textureLine .control3D .ny {
  grid-column: 5;
}
#actionTabs .tabsMenu .panes .pane .textureLine .control3D .pz {
  grid-column: 6;
}
#actionTabs .tabsMenu .panes .pane .textureLine .control3D .nz {
  grid-column: 7;
}
#actionTabs .tabsMenu .panes .pane .textureLine .command {
  border: 1px solid transparent;
  background: transparent;
  color: white;
}
#actionTabs .tabsMenu .panes .pane .textureLine .selected {
  border: 1px solid rgb(51, 122, 183);
}
#actionTabs .tabsMenu .panes .pane .textureLine .preview {
  grid-row: 2;
  display: grid;
  align-self: center;
  justify-self: center;
  height: 256px;
  width: 256px;
  margin-top: 5px;
  margin-bottom: 5px;
  border: 1px solid white;
  background-size: 32px 32px;
  background-color: white;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
#actionTabs .tabsMenu .panes .pane .gltf-extension-property {
  margin-left: 30px;
  border-left: 1px solid rgb(51, 122, 183);
}
#actionTabs .tabsMenu .panes .pane .floatLine {
  padding-left: 2px;
  height: 30px;
  display: grid;
  grid-template-columns: 1fr 120px;
}
#actionTabs .tabsMenu .panes .pane .floatLine .label {
  grid-column: 1;
  display: flex;
  align-items: center;
}
#actionTabs .tabsMenu .panes .pane .floatLine .value {
  grid-column: 2;
  display: flex;
  align-items: center;
}
#actionTabs .tabsMenu .panes .pane .floatLine .value input {
  width: 110px;
}
#actionTabs .tabsMenu .panes .pane .sliderLine {
  padding-left: 2px;
  height: 30px;
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: 1fr 50px auto;
}
#actionTabs .tabsMenu .panes .pane .sliderLine .label {
  grid-column: 1;
  display: flex;
  align-items: center;
}
#actionTabs .tabsMenu .panes .pane .sliderLine .withMargins {
  margin-left: 5px;
}
#actionTabs .tabsMenu .panes .pane .sliderLine .floatLine {
  padding-left: 2px;
}
#actionTabs .tabsMenu .panes .pane .sliderLine .floatLine .short {
  grid-column: 1;
  display: flex;
  align-items: center;
}
#actionTabs .tabsMenu .panes .pane .sliderLine .floatLine .short input {
  width: 35px;
}
#actionTabs .tabsMenu .panes .pane .sliderLine .floatLine .short input::-webkit-outer-spin-button,
#actionTabs .tabsMenu .panes .pane .sliderLine .floatLine .short input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
#actionTabs .tabsMenu .panes .pane .sliderLine .floatLine .short input[type=number] {
  -moz-appearance: textfield;
}
#actionTabs .tabsMenu .panes .pane .sliderLine .slider {
  grid-column: 3;
  grid-row: 1;
  margin-right: 5px;
  width: 90%;
  display: flex;
  align-items: center;
}
#actionTabs .tabsMenu .panes .pane .sliderLine .slider .range {
  -webkit-appearance: none;
  width: 100%;
  height: 6px;
  background: #d3d3d3;
  border-radius: 5px;
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
}
#actionTabs .tabsMenu .panes .pane .sliderLine .slider .range:hover {
  opacity: 1;
}
#actionTabs .tabsMenu .panes .pane .sliderLine .slider .range::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: rgb(51, 122, 183);
  cursor: pointer;
}
#actionTabs .tabsMenu .panes .pane .sliderLine .slider .range::-moz-range-thumb {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: rgb(51, 122, 183);
  cursor: pointer;
}
#actionTabs .tabsMenu .panes .pane .color3Line {
  padding-left: 2px;
  display: grid;
}
#actionTabs .tabsMenu .panes .pane .color3Line .firstLine {
  height: 30px;
  display: grid;
  grid-template-columns: 1fr auto 20px 20px;
}
#actionTabs .tabsMenu .panes .pane .color3Line .firstLine .label {
  grid-column: 1;
  display: flex;
  align-items: center;
}
#actionTabs .tabsMenu .panes .pane .color3Line .firstLine .color3 {
  grid-column: 2;
  width: 50px;
  display: flex;
  align-items: center;
}
#actionTabs .tabsMenu .panes .pane .color3Line .firstLine .color3 input[type=color] {
  -webkit-appearance: none;
  border: 1px solid rgba(255, 255, 255, 0.5);
  padding: 0;
  width: 30px;
  height: 20px;
}
#actionTabs .tabsMenu .panes .pane .color3Line .firstLine .color3 input[type=color]::-webkit-color-swatch-wrapper {
  padding: 0;
}
#actionTabs .tabsMenu .panes .pane .color3Line .firstLine .color3 input[type=color]::-webkit-color-swatch {
  border: none;
}
#actionTabs .tabsMenu .panes .pane .color3Line .firstLine .color3 input {
  margin-right: 5px;
}
#actionTabs .tabsMenu .panes .pane .color3Line .firstLine .copy {
  grid-column: 3;
  display: grid;
  align-items: center;
  justify-items: center;
  cursor: pointer;
}
#actionTabs .tabsMenu .panes .pane .color3Line .firstLine .copy img {
  height: 100%;
}
#actionTabs .tabsMenu .panes .pane .color3Line .firstLine .expand {
  grid-column: 4;
  display: grid;
  align-items: center;
  justify-items: center;
  cursor: pointer;
}
#actionTabs .tabsMenu .panes .pane .color3Line .secondLine {
  display: grid;
  padding-right: 5px;
  border-left: 1px solid rgb(51, 122, 183);
}
#actionTabs .tabsMenu .panes .pane .color3Line .secondLine .numeric {
  display: grid;
  grid-template-columns: 1fr auto;
}
#actionTabs .tabsMenu .panes .pane .color3Line .secondLine .numeric-label {
  text-align: right;
  grid-column: 1;
  display: flex;
  align-items: center;
  justify-self: right;
  margin-right: 10px;
}
#actionTabs .tabsMenu .panes .pane .color3Line .secondLine .numeric-value {
  width: 120px;
  grid-column: 2;
  display: flex;
  align-items: center;
  border: 1px solid rgb(51, 122, 183);
}
#actionTabs .tabsMenu .panes .pane .listLine {
  padding-left: 2px;
  height: 30px;
  display: grid;
  grid-template-columns: 1fr auto;
}
#actionTabs .tabsMenu .panes .pane .listLine .label {
  grid-column: 1;
  display: flex;
  align-items: center;
}
#actionTabs .tabsMenu .panes .pane .listLine .options {
  grid-column: 2;
  display: flex;
  align-items: center;
  margin-right: 5px;
}
#actionTabs .tabsMenu .panes .pane .listLine .options select {
  width: 115px;
}
#actionTabs .tabsMenu .panes .pane .paneContainer {
  margin-top: 3px;
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: 100%;
}
#actionTabs .tabsMenu .panes .pane .paneContainer .paneList {
  border-left: 3px solid transparent;
}
#actionTabs .tabsMenu .panes .pane .paneContainer:hover .paneList {
  border-left: 3px solid rgba(51, 122, 183, 0.8);
}
#actionTabs .tabsMenu .panes .pane .paneContainer:hover .paneContainer-content .header .title {
  border-left: 3px solid rgb(51, 122, 183);
}
#actionTabs .tabsMenu .panes .pane .paneContainer .paneContainer-highlight-border {
  grid-row: 1;
  grid-column: 1;
  opacity: 1;
  border: 3px solid red;
  margin-bottom: -5px;
  z-index: 100;
  transition: opacity 250ms;
  pointer-events: none;
}
#actionTabs .tabsMenu .panes .pane .paneContainer .paneContainer-highlight-border.transparent {
  opacity: 0;
}
#actionTabs .tabsMenu .panes .pane .paneContainer .paneContainer-content {
  grid-row: 1;
  grid-column: 1;
}
#actionTabs .tabsMenu .panes .pane .paneContainer .paneContainer-content .header {
  display: grid;
  grid-template-columns: 1fr auto;
  background: #555555;
  height: 30px;
  padding-right: 5px;
  cursor: pointer;
}
#actionTabs .tabsMenu .panes .pane .paneContainer .paneContainer-content .header .title {
  border-left: 3px solid transparent;
  padding-left: 5px;
  grid-column: 1;
  display: flex;
  align-items: center;
}
#actionTabs .tabsMenu .panes .pane .paneContainer .paneContainer-content .header .collapse {
  grid-column: 2;
  display: flex;
  align-items: center;
  justify-items: center;
  transform-origin: center;
}
#actionTabs .tabsMenu .panes .pane .paneContainer .paneContainer-content .header .collapse.closed {
  transform: rotate(180deg);
}
#actionTabs .tabsMenu .panes .pane .paneContainer .paneContainer-content .paneList > div:not(:last-child) {
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.1);
}
#actionTabs .tabsMenu .panes .pane .paneContainer .paneContainer-content .fragment > div:not(:last-child) {
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.1);
}`, "",{"version":3,"sources":["webpack://./../../../dev/inspector/dist/components/actionTabs/actionTabs.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;AADJ;;AAIA;EACI,aAAA;AADJ;;AAIA;EACI,mBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;AADJ;AAGI;EACI,YAAA;AADR;AAII;EACI,YAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,oCAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AAFR;AAIQ;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;AAFZ;AAKQ;EACI,cAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;AAHZ;AAMQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAJZ;AAOQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AALZ;AAOY;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AALhB;AAQY;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AANhB;AAWI;EACI,aAAA;EACA,WAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;AATR;AAWQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,gCAAA;EACA,SAAA;EACA,UAAA;AATZ;AAWY;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAThB;AAWgB;EACI,qBAAA;EACA,oCAAA;EACA,mBAAA;AATpB;AAcQ;EACI,WAAA;EACA,aAAA;EACA,wBAAA;EAEA,gBAAA;AAbZ;AAeY;EACI,YAAA;EACA,YAAA;EACA,wBAAA;AAbhB;AAgBY;EACI,aAAA;EACA,wBAAA;EACA,oDAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AAdhB;AAgBgB;EACI,WAAA;EACA,cAAA;AAdpB;AAiBgB;EACI,YAAA;AAfpB;AAkBgB;EACI,YAAA;EACA,iBAAA;AAhBpB;AAmBgB;EACI,WAAA;EACA,cAAA;EACA,eAAA;AAjBpB;AAoBgB;EACI,iBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AAlBpB;AAoBoB;EACI,gBAAA;EACA,kBAAA;AAlBxB;AAsBgB;EACI,uBAAA;AApBpB;AAuBgB;EACI,eAAA;AArBpB;AAwBgB;EACI,gBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AAtBpB;AAyBgB;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;AAvBpB;AAyBoB;EACI,WAAA;AAvBxB;AAyBoB;EACI,UAAA;AAvBxB;AA0BoB;EACI,wBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,wBAAA;EACA,wBAAA;AAxBxB;AA0BoB;EACI,wBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;AAxBxB;AA2BoB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;AAzBxB;AA6BgB;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;AA3BpB;AA6BoB;EACI,YAAA;EACA,WAAA;AA3BxB;AA6BoB;EACI,eAAA;AA3BxB;AA8BgB;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;AA5BpB;AA6BoB;EACI,YAAA;EACA,WAAA;AA3BxB;AA6BoB;EACI,eAAA;AA3BxB;AAgCY;EACI,YAAA;EAEA,kBAAA;EACA,gBAAA;EACA,YAAA;EAEA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AAhChB;AAkCgB;EACI,kCAAA;EACA,gBAAA;EACA,4BAAA;AAhCpB;AAmCgB;EACI,mDAAA;AAjCpB;AAoCgB;EACI,aAAA;EACA,+BAAA;AAlCpB;AAoCoB;EACI,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;AAlCxB;AAoCwB;EACI,UAAA;AAlC5B;AAsCoB;EACI,cAAA;AApCxB;AAuCoB;EACI,qBAAA;EACA,eAAA;EACA,iBAAA;AArCxB;AAyCgB;EACI,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AAvCpB;AA0CgB;EACI,iBA5UA;EA6UA,YAAA;EACA,aAAA;EACA,+BAAA;AAxCpB;AA0CoB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AAxCxB;AA2CoB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AAzCxB;AA6CgB;EACI,wBAAA;EACA,WAAA;EACA,WAAA;AA3CpB;AA6CoB;EACI,wBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AA3CxB;AA8CoB;EACI,eAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;AA5CxB;AA+CoB;EACI,kBAAA;AA7CxB;AAiDgB;EACI,iBA1XA;EA2XA,YAAA;EACA,aAAA;EACA,oCAAA;AA/CpB;AAiDoB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;AA/CxB;AAkDoB;EACI,cAAA;AAhDxB;AAkDwB;EACI,mBAAA;EACA,mCAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAhD5B;AAmDwB;EACI,UAAA;AAjD5B;AAoDwB;EACI,mBAAA;AAlD5B;AAqDwB;EACI,mCAAA;EACA,YAAA;AAnD5B;AAuDoB;EACI,cAAA;EACA,aAAA;EACA,qBAAA;AArDxB;AAyDgB;EACI,iBA1aA;EA2aA,YAAA;EACA,aAAA;EACA,+BAAA;AAvDpB;AAyDoB;EACI,2BAAA;AAvDxB;AAyDwB;EACI,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AAvD5B;AA0DwB;EACI,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AAxD5B;AA4DoB;EACI,YAAA;EACA,kBAAA;AA1DxB;AA6DoB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AA3DxB;AA8DoB;EACI,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;AA5DxB;AA+DoB;EACI,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AA7DxB;AA+DwB;EACI,YAAA;AA7D5B;AAgEwB;EACI,UAAA;AA9D5B;AAmEgB;EACI,eAAA;AAjEpB;AAmEoB;EACI,YAAA;EACA,aAAA;EACA,qBAAA;AAjExB;AAoEoB;EACI,aAAA;EACA,wBAAA;EACA,wDAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;AAlExB;AAoEwB;EACI,WAAA;EACA,cAAA;AAlE5B;AAqEwB;EACI,YAAA;AAnE5B;AAsEwB;EACI,YAAA;EACA,iBAAA;AApE5B;AAuEwB;EACI,WAAA;EACA,cAAA;EACA,eAAA;AArE5B;AAwEwB;EACI,iBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AAtE5B;AAwE4B;EACI,gBAAA;EACA,kBAAA;AAtEhC;AA0EwB;EACI,uBAAA;AAxE5B;AA2EwB;EACI,gBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AAzE5B;AA4EwB;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,wBAAA;EACA,qBAAA;EACA,iBAAA;AA1E5B;AA4E4B;EACI,WAAA;AA1EhC;AA8EwB;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;AA5E5B;AAiFgB;EACI,iBA5kBA;EA6kBA,YAAA;EACA,aAAA;EACA,gCAAA;AA/EpB;AAiFoB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AA/ExB;AAkFoB;EACI,aAAA;EACA,mBAAA;EACA,cAAA;AAhFxB;AAkFwB;EACI,YAAA;AAhF5B;AAqFgB;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AAnFpB;AAqFoB;EACI,aAAA;AAnFxB;AAsFoB;EACI,mBAAA;EACA,mCAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AApFxB;AAuFoB;EACI,UAAA;AArFxB;AAwFoB;EACI,sBAAA;EACA,yBAAA;AAtFxB;AAyFoB;EACI,mBAAA;EACA,mCAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAvFxB;AA0FoB;EACI,UAAA;AAxFxB;AA2FoB;EACI,mBAAA;AAzFxB;AA4FoB;EACI,mCAAA;EACA,YAAA;AA1FxB;AA8FgB;EACI,iBA1pBA;EA2pBA,YAAA;EACA,aAAA;EACA,+BAAA;AA5FpB;AA8FoB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AA5FxB;AA+FoB;EACI,aAAA;EACA,mBAAA;AA7FxB;AA+FwB;EACI,cAAA;EACA,aAAA;AA7F5B;AA+F4B;EACI,+BAAA;AA7FhC;AA+F4B;EACI,mBAAA;AA7FhC;AAiGwB;EACI,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AA/F5B;AAgG4B;EAEI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,4CAAA;AA/FhC;AAiG4B;EACI,SAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;AA/FhC;AAiG4B;EACI,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,6BAAA;AA/FhC;AAqGgB;EACI,iBAztBA;EA0tBA,aAAA;AAnGpB;AAqGoB;EACI,aAAA;EACA,oCAAA;EACA,YAAA;AAnGxB;AAqGwB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAnG5B;AAsGwB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;AApG5B;AAuGwB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AArG5B;AAyGoB;EACI,aAAA;EACA,kBAAA;EACA,wCAAA;AAvGxB;AAyGwB;EACI,aAAA;EACA,+BAAA;AAvG5B;AA0GwB;EACI,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AAxG5B;AA2GwB;EACI,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mCAAA;AAzG5B;AA8GgB;EACI,iBAzxBA;EA0xBA,YAAA;EACA,aAAA;EACA,+BAAA;AA5GpB;AA8GoB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AA5GxB;AA+GoB;EACI,cAAA;EAEA,aAAA;EACA,mBAAA;AA9GxB;AAgHwB;EACI,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,yBAAA;AA9G5B;AAgH4B;EACI,6BAAA;AA9GhC;AAkHwB;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,2CAAA;EACA,WAAA;EACA,0BAAA;AAhH5B;AAkH4B;EACI,UAAA;EACA,4BAAA;AAhHhC;AAoHwB;EACI,kBAAA;EACA,QAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,2CAAA;EACA,WAAA;EACA,0BAAA;EACA,UAAA;EACA,4BAAA;AAlH5B;AAqHwB;EACI,4BAAA;AAnH5B;AAsHwB;EACI,aAAA;AApH5B;AAuHwB;EACI,aAAA;AArH5B;AA0HgB;EACI,aAAA;EACA,6BAAA;AAxHpB;AA0HoB;EACI,eAAA;EACA,WAAA;EACA,aAAA;EACA,uDAAA;AAxHxB;AA0HwB;EACI,cAAA;AAxH5B;AA2HwB;EACI,cAAA;AAzH5B;AA4HwB;EACI,cAAA;AA1H5B;AA6HwB;EACI,cAAA;AA3H5B;AA8HwB;EACI,cAAA;AA5H5B;AAgIoB;EACI,eAAA;EACA,WAAA;EACA,aAAA;EACA,4DAAA;AA9HxB;AAgIwB;EACI,cAAA;AA9H5B;AAiIwB;EACI,cAAA;AA/H5B;AAkIwB;EACI,cAAA;AAhI5B;AAmIwB;EACI,cAAA;AAjI5B;AAoIwB;EACI,cAAA;AAlI5B;AAqIwB;EACI,cAAA;AAnI5B;AAuIoB;EACI,6BAAA;EACA,uBAAA;EACA,YAAA;AArIxB;AAwIoB;EACI,mCAAA;AAtIxB;AAyIoB;EACI,WAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,0BAAA;EACA,uBAAA;EACA,yDAAA;AAvIxB;AA2IgB;EACI,iBAAA;EACA,wCAAA;AAzIpB;AA4IgB;EACI,iBAx8BA;EAy8BA,YAAA;EACA,aAAA;EACA,gCAAA;AA1IpB;AA4IoB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AA1IxB;AA6IoB;EACI,cAAA;EAEA,aAAA;EACA,mBAAA;AA5IxB;AA8IwB;EACI,YAAA;AA5I5B;AAiJgB;EACI,iBAh+BA;EAi+BA,YAAA;EACA,aAAA;EACA,wBAAA;EACA,oCAAA;AA/IpB;AAiJoB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AA/IxB;AAkJoB;EACI,gBAAA;AAhJxB;AAmJoB;EACI,iBAj/BJ;AAg2BpB;AAmJwB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AAjJ5B;AAmJ4B;EACI,WAAA;AAjJhC;AAoJ4B;;EAEI,wBAAA;EACA,SAAA;AAlJhC;AAqJ4B;EACI,0BAAA;AAnJhC;AAwJoB;EACI,cAAA;EACA,WAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AAtJxB;AAwJwB;EACI,wBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,wBAAA;EACA,wBAAA;AAtJ5B;AAyJwB;EACI,UAAA;AAvJ5B;AA0JwB;EACI,wBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;AAxJ5B;AA2JwB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;AAzJ5B;AA8JgB;EACI,iBArjCA;EAsjCA,aAAA;AA5JpB;AA8JoB;EACI,YAAA;EACA,aAAA;EACA,yCAAA;AA5JxB;AA8JwB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AA5J5B;AA+JwB;EACI,cAAA;EACA,WAAA;EAEA,aAAA;EACA,mBAAA;AA9J5B;AAgK4B;EACI,wBAAA;EACA,0CAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AA9JhC;AAgK4B;EACI,UAAA;AA9JhC;AAgK4B;EACI,YAAA;AA9JhC;AAiK4B;EACI,iBAAA;AA/JhC;AAmKwB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AAjK5B;AAkK4B;EACI,YAAA;AAhKhC;AAoKwB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AAlK5B;AAsKoB;EACI,aAAA;EACA,kBAAA;EACA,wCAAA;AApKxB;AAsKwB;EACI,aAAA;EACA,+BAAA;AApK5B;AAuKwB;EACI,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AArK5B;AAwKwB;EACI,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mCAAA;AAtK5B;AA2KgB;EACI,iBA/oCA;EAgpCA,YAAA;EACA,aAAA;EACA,+BAAA;AAzKpB;AA2KoB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AAzKxB;AA4KoB;EACI,cAAA;EAEA,aAAA;EACA,mBAAA;EACA,iBAAA;AA3KxB;AA6KwB;EACI,YAAA;AA3K5B;AAgLgB;EACI,eAAA;EACA,aAAA;EACA,wBAAA;EACA,2BAAA;AA9KpB;AAgLoB;EACI,kCAAA;AA9KxB;AAkLwB;EACI,8CAAA;AAhL5B;AAqLgC;EACI,wCAAA;AAnLpC;AAyLoB;EACI,WAAA;EACA,cAAA;EACA,UAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,oBAAA;AAvLxB;AAyLwB;EACI,UAAA;AAvL5B;AA2LoB;EACI,WAAA;EACA,cAAA;AAzLxB;AA2LwB;EACI,aAAA;EACA,+BAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAzL5B;AA2L4B;EACI,kCAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAzLhC;AA4L4B;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,wBAAA;AA1LhC;AA4LgC;EACI,yBAAA;AA1LpC;AA+LwB;EACI,mDAAA;AA7L5B;AAgMwB;EACI,mDAAA;AA9L5B","sourcesContent":["$line-padding-left: 2px;\r\n\r\n#inspector-host {\r\n    position: absolute;\r\n    right: 0px;\r\n    top: 0px;\r\n    bottom: 0px;\r\n}\r\n\r\n#__resizable_base__ {\r\n    display: none;\r\n}\r\n\r\n#actionTabs {\r\n    background: #333333;\r\n    height: 100%;\r\n    margin: 0;\r\n    padding: 0;\r\n    display: grid;\r\n    grid-template-rows: auto 1fr;\r\n    font: 14px \"Arial\";\r\n    overflow: hidden;\r\n\r\n    .hoverIcon:hover {\r\n        opacity: 0.8;\r\n    }\r\n\r\n    #header {\r\n        height: 30px;\r\n        font-size: 16px;\r\n        color: white;\r\n        background: #222222;\r\n        grid-row: 1;\r\n        text-align: center;\r\n        display: grid;\r\n        grid-template-columns: 30px 1fr 50px;\r\n        -webkit-user-select: none;\r\n        -moz-user-select: none;\r\n        -ms-user-select: none;\r\n        user-select: none;\r\n\r\n        #logo {\r\n            grid-column: 1;\r\n            width: 24px;\r\n            height: 24px;\r\n            display: flex;\r\n            align-self: center;\r\n            justify-self: center;\r\n        }\r\n\r\n        #back {\r\n            grid-column: 1;\r\n            display: grid;\r\n            align-self: center;\r\n            justify-self: center;\r\n            cursor: pointer;\r\n        }\r\n\r\n        #title {\r\n            grid-column: 2;\r\n            display: grid;\r\n            align-items: center;\r\n            text-align: center;\r\n        }\r\n\r\n        #commands {\r\n            grid-column: 3;\r\n            display: grid;\r\n            align-items: center;\r\n            grid-template-columns: 1fr 1fr;\r\n\r\n            .expand {\r\n                grid-column: 1;\r\n                display: grid;\r\n                align-items: center;\r\n                justify-items: center;\r\n                cursor: pointer;\r\n            }\r\n\r\n            .close {\r\n                grid-column: 2;\r\n                display: grid;\r\n                align-items: center;\r\n                justify-items: center;\r\n                cursor: pointer;\r\n            }\r\n        }\r\n    }\r\n\r\n    .tabsMenu {\r\n        display: grid;\r\n        grid-row: 2;\r\n        grid-template-rows: 40px 1fr;\r\n        font: 14px \"Arial\";\r\n        overflow: hidden;\r\n\r\n        .labels {\r\n            grid-row: 1;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-items: center;\r\n            border-bottom: 1px solid #ffffff;\r\n            margin: 0;\r\n            padding: 0;\r\n\r\n            .label {\r\n                font-size: 24px;\r\n                color: white;\r\n                width: 40px;\r\n                display: flex;\r\n                align-content: center;\r\n                justify-content: center;\r\n                border: 1px solid transparent;\r\n                border-bottom: none;\r\n                background: #333333;\r\n                padding: 5px;\r\n                height: 28px;\r\n                cursor: pointer;\r\n\r\n                &.active {\r\n                    border-color: #ffffff;\r\n                    border-bottom: 2px solid transparent;\r\n                    margin-bottom: -2px;\r\n                }\r\n            }\r\n        }\r\n\r\n        .panes {\r\n            grid-row: 2;\r\n            display: grid;\r\n            grid-template-rows: 100%;\r\n\r\n            overflow: hidden;\r\n\r\n            .infoMessage {\r\n                opacity: 0.5;\r\n                color: white;\r\n                margin: 15px 5px 0px 5px;\r\n            }\r\n\r\n            .gradient-step {\r\n                display: grid;\r\n                grid-template-rows: 100%;\r\n                grid-template-columns: 20px 30px 40px auto 20px 30px;\r\n                padding-top: 5px;\r\n                padding-left: 5px;\r\n                padding-bottom: 5px;\r\n                align-items: center;\r\n\r\n                .step {\r\n                    grid-row: 1;\r\n                    grid-column: 1;\r\n                }\r\n\r\n                .color1 {\r\n                    height: 100%;\r\n                }\r\n\r\n                .color2 {\r\n                    height: 100%;\r\n                    padding-left: 5px;\r\n                }\r\n\r\n                .factor1 {\r\n                    grid-row: 1;\r\n                    grid-column: 2;\r\n                    cursor: pointer;\r\n                }\r\n\r\n                .factor2 {\r\n                    padding-left: 5px;\r\n                    grid-row: 1;\r\n                    grid-column: 3;\r\n                    cursor: pointer;\r\n\r\n                    .grayed {\r\n                        background: gray;\r\n                        border-color: gray;\r\n                    }\r\n                }\r\n\r\n                .numeric-input {\r\n                    width: calc(100% - 5px);\r\n                }\r\n\r\n                .icon {\r\n                    cursor: pointer;\r\n                }\r\n\r\n                .step-value {\r\n                    margin-left: 5px;\r\n                    grid-row: 1;\r\n                    grid-column: 3;\r\n                    text-align: right;\r\n                    margin-right: 5px;\r\n                }\r\n\r\n                .step-slider {\r\n                    grid-row: 1;\r\n                    grid-column: 4;\r\n                    display: grid;\r\n                    justify-content: stretch;\r\n                    align-content: center;\r\n                    margin-right: 12px;\r\n\r\n                    input {\r\n                        width: 100%;\r\n                    }\r\n                    .range:hover {\r\n                        opacity: 1;\r\n                    }\r\n\r\n                    .range {\r\n                        -webkit-appearance: none;\r\n                        height: 6px;\r\n                        background: #d3d3d3;\r\n                        border-radius: 5px;\r\n                        outline: none;\r\n                        opacity: 0.7;\r\n                        -webkit-transition: 0.2s;\r\n                        transition: opacity 0.2s;\r\n                    }\r\n                    .range::-webkit-slider-thumb {\r\n                        -webkit-appearance: none;\r\n                        appearance: none;\r\n                        width: 14px;\r\n                        height: 14px;\r\n                        border-radius: 50%;\r\n                        background: rgb(51, 122, 183);\r\n                        cursor: pointer;\r\n                    }\r\n\r\n                    .range::-moz-range-thumb {\r\n                        width: 14px;\r\n                        height: 14px;\r\n                        border-radius: 50%;\r\n                        background: rgb(51, 122, 183);\r\n                        cursor: pointer;\r\n                    }\r\n                }\r\n\r\n                .gradient-copy {\r\n                    grid-row: 1;\r\n                    grid-column: 5;\r\n                    display: grid;\r\n                    align-content: center;\r\n                    justify-content: center;\r\n\r\n                    .img {\r\n                        height: 20px;\r\n                        width: 20px;\r\n                    }\r\n                    .img:hover {\r\n                        cursor: pointer;\r\n                    }\r\n                }\r\n                .gradient-delete {\r\n                    grid-row: 1;\r\n                    grid-column: 6;\r\n                    display: grid;\r\n                    align-content: center;\r\n                    justify-content: center;\r\n                    .img {\r\n                        height: 20px;\r\n                        width: 20px;\r\n                    }\r\n                    .img:hover {\r\n                        cursor: pointer;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .pane {\r\n                color: white;\r\n\r\n                overflow-x: hidden;\r\n                overflow-y: auto;\r\n                height: 100%;\r\n\r\n                -webkit-user-select: none;\r\n                -moz-user-select: none;\r\n                -ms-user-select: none;\r\n                user-select: none;\r\n\r\n                .animation-info {\r\n                    border-left: greenyellow 3px solid;\r\n                    margin-left: 5px;\r\n                    padding-left: 5px !important;\r\n                }\r\n\r\n                .underline {\r\n                    border-bottom: 0.5px solid rgba(255, 255, 255, 0.5);\r\n                }\r\n\r\n                .textureLinkLine {\r\n                    display: grid;\r\n                    grid-template-columns: auto 1fr;\r\n\r\n                    .debug {\r\n                        grid-column: 1;\r\n                        margin-left: 5px;\r\n                        margin-right: 5px;\r\n                        display: block;\r\n                        align-items: center;\r\n                        justify-items: center;\r\n                        cursor: pointer;\r\n                        opacity: 0.5;\r\n\r\n                        &.selected {\r\n                            opacity: 1;\r\n                        }\r\n                    }\r\n\r\n                    .textLine {\r\n                        grid-column: 2;\r\n                    }\r\n\r\n                    .actionIcon {\r\n                        display: inline-block;\r\n                        margin-top: 6px;\r\n                        margin-right: 4px;\r\n                    }\r\n                }\r\n\r\n                .messageLine {\r\n                    text-align: center;\r\n                    font-size: 12px;\r\n                    font-style: italic;\r\n                    opacity: 0.6;\r\n                }\r\n\r\n                .iconMessageLine {\r\n                    padding-left: $line-padding-left;\r\n                    height: 30px;\r\n                    display: grid;\r\n                    grid-template-columns: 30px 1fr;\r\n\r\n                    .icon {\r\n                        grid-column: 1;\r\n                        display: grid;\r\n                        align-items: center;\r\n                        justify-items: center;\r\n                    }\r\n\r\n                    .value {\r\n                        grid-column: 2;\r\n                        display: flex;\r\n                        align-items: center;\r\n                    }\r\n                }\r\n\r\n                .color-picker {\r\n                    height: calc(100% - 8px);\r\n                    margin: 4px;\r\n                    width: 100%;\r\n\r\n                    .color-rect {\r\n                        height: calc(100% - 4px);\r\n                        border: 2px white solid;\r\n                        cursor: pointer;\r\n                        min-height: 18px;\r\n                    }\r\n\r\n                    .color-picker-cover {\r\n                        position: fixed;\r\n                        top: 0px;\r\n                        right: 0px;\r\n                        bottom: 0px;\r\n                        left: 0px;\r\n                        z-index: 100;\r\n                    }\r\n\r\n                    .color-picker-float {\r\n                        position: absolute;\r\n                    }\r\n                }\r\n\r\n                .linkButtonLine {\r\n                    padding-left: $line-padding-left;\r\n                    height: 30px;\r\n                    display: grid;\r\n                    grid-template-columns: 1fr auto 20px;\r\n\r\n                    .link {\r\n                        grid-column: 1;\r\n                        display: flex;\r\n                        align-items: center;\r\n                        text-decoration: underline;\r\n                        cursor: pointer;\r\n                    }\r\n\r\n                    .link-button {\r\n                        grid-column: 2;\r\n\r\n                        button {\r\n                            background: #222222;\r\n                            border: 1px solid rgb(51, 122, 183);\r\n                            margin: 5px 10px 5px 10px;\r\n                            color: white;\r\n                            padding: 4px 5px;\r\n                            opacity: 0.9;\r\n                            cursor: pointer;\r\n                        }\r\n\r\n                        button:hover {\r\n                            opacity: 1;\r\n                        }\r\n\r\n                        button:active {\r\n                            background: #282828;\r\n                        }\r\n\r\n                        button:focus {\r\n                            border: 1px solid rgb(51, 122, 183);\r\n                            outline: 0px;\r\n                        }\r\n                    }\r\n\r\n                    .link-icon {\r\n                        grid-column: 3;\r\n                        display: grid;\r\n                        align-content: center;\r\n                    }\r\n                }\r\n\r\n                .textLine {\r\n                    padding-left: $line-padding-left;\r\n                    height: 30px;\r\n                    display: grid;\r\n                    grid-template-columns: 1fr auto;\r\n\r\n                    &.indented {\r\n                        grid-template-columns: 100%;\r\n\r\n                        .link-value {\r\n                            grid-column: 1;\r\n                            text-align: start;\r\n                            margin-left: 20px;\r\n                            opacity: 0.6;\r\n                            max-width: unset;\r\n                        }\r\n\r\n                        .value {\r\n                            grid-column: 1;\r\n                            text-align: start;\r\n                            margin-left: 20px;\r\n                            opacity: 0.6;\r\n                            max-width: unset;\r\n                        }\r\n                    }\r\n\r\n                    &.reduced-opacity {\r\n                        opacity: 0.6;\r\n                        padding-left: 25px;\r\n                    }\r\n\r\n                    .label {\r\n                        grid-column: 1;\r\n                        display: flex;\r\n                        align-items: center;\r\n                    }\r\n\r\n                    .link-value {\r\n                        grid-column: 2;\r\n                        white-space: nowrap;\r\n                        text-overflow: ellipsis;\r\n                        overflow: hidden;\r\n                        text-align: end;\r\n                        opacity: 0.8;\r\n                        margin: 5px;\r\n                        margin-top: 7px;\r\n                        max-width: 140px;\r\n                        text-decoration: underline;\r\n                        cursor: pointer;\r\n                    }\r\n\r\n                    .value {\r\n                        grid-column: 2;\r\n                        white-space: nowrap;\r\n                        text-overflow: ellipsis;\r\n                        overflow: hidden;\r\n                        text-align: end;\r\n                        opacity: 0.8;\r\n                        margin: 5px;\r\n                        margin-top: 7px;\r\n                        max-width: 200px;\r\n                        -webkit-user-select: text;\r\n                        -moz-user-select: text;\r\n                        -ms-user-select: text;\r\n                        user-select: text;\r\n\r\n                        &.check {\r\n                            color: green;\r\n                        }\r\n\r\n                        &.uncheck {\r\n                            color: red;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .gradient-container {\r\n                    margin-top: 3px;\r\n\r\n                    .gradient-label {\r\n                        height: 30px;\r\n                        display: grid;\r\n                        align-content: center;\r\n                    }\r\n\r\n                    .gradient-step {\r\n                        display: grid;\r\n                        grid-template-rows: 100%;\r\n                        grid-template-columns: 25px 50px 55px 40px auto 20px 5px;\r\n                        padding-top: 5px;\r\n                        padding-left: 5px;\r\n                        padding-bottom: 5px;\r\n                        align-items: center;\r\n                        border-left: orange 3px solid;\r\n\r\n                        .step {\r\n                            grid-row: 1;\r\n                            grid-column: 1;\r\n                        }\r\n\r\n                        .color1 {\r\n                            height: 100%;\r\n                        }\r\n\r\n                        .color2 {\r\n                            height: 100%;\r\n                            padding-left: 5px;\r\n                        }\r\n\r\n                        .factor1 {\r\n                            grid-row: 1;\r\n                            grid-column: 2;\r\n                            cursor: pointer;\r\n                        }\r\n\r\n                        .factor2 {\r\n                            padding-left: 5px;\r\n                            grid-row: 1;\r\n                            grid-column: 3;\r\n                            cursor: pointer;\r\n\r\n                            .grayed {\r\n                                background: gray;\r\n                                border-color: gray;\r\n                            }\r\n                        }\r\n\r\n                        .numeric-input {\r\n                            width: calc(100% - 5px);\r\n                        }\r\n\r\n                        .step-value {\r\n                            margin-left: 5px;\r\n                            grid-row: 1;\r\n                            grid-column: 4;\r\n                            text-align: right;\r\n                            margin-right: 5px;\r\n                        }\r\n\r\n                        .step-slider {\r\n                            grid-row: 1;\r\n                            grid-column: 5;\r\n                            display: grid;\r\n                            justify-content: stretch;\r\n                            align-content: center;\r\n                            margin-right: 5px;\r\n\r\n                            input {\r\n                                width: 100%;\r\n                            }\r\n                        }\r\n\r\n                        .gradient-delete {\r\n                            grid-row: 1;\r\n                            grid-column: 6;\r\n                            display: grid;\r\n                            align-content: center;\r\n                            justify-content: center;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .textInputLine {\r\n                    padding-left: $line-padding-left;\r\n                    height: 30px;\r\n                    display: grid;\r\n                    grid-template-columns: 1fr 120px;\r\n\r\n                    .label {\r\n                        grid-column: 1;\r\n                        display: flex;\r\n                        align-items: center;\r\n                    }\r\n\r\n                    .value {\r\n                        display: flex;\r\n                        align-items: center;\r\n                        grid-column: 2;\r\n\r\n                        input {\r\n                            width: 110px;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .buttonLine {\r\n                    height: 30px;\r\n                    display: grid;\r\n                    align-items: center;\r\n                    justify-items: stretch;\r\n\r\n                    input[type=\"file\"] {\r\n                        display: none;\r\n                    }\r\n\r\n                    .file-upload {\r\n                        background: #222222;\r\n                        border: 1px solid rgb(51, 122, 183);\r\n                        margin: 5px 10px 5px 10px;\r\n                        color: white;\r\n                        padding: 4px 5px;\r\n                        font-size: 13px;\r\n                        opacity: 0.9;\r\n                        cursor: pointer;\r\n                        text-align: center;\r\n                    }\r\n\r\n                    .file-upload:hover {\r\n                        opacity: 1;\r\n                    }\r\n\r\n                    .file-upload:active {\r\n                        transform: scale(0.98);\r\n                        transform-origin: 0.5 0.5;\r\n                    }\r\n\r\n                    button {\r\n                        background: #222222;\r\n                        border: 1px solid rgb(51, 122, 183);\r\n                        margin: 5px 10px 5px 10px;\r\n                        color: white;\r\n                        padding: 4px 5px;\r\n                        opacity: 0.9;\r\n                        cursor: pointer;\r\n                    }\r\n\r\n                    button:hover {\r\n                        opacity: 1;\r\n                    }\r\n\r\n                    button:active {\r\n                        background: #282828;\r\n                    }\r\n\r\n                    button:focus {\r\n                        border: 1px solid rgb(51, 122, 183);\r\n                        outline: 0px;\r\n                    }\r\n                }\r\n\r\n                .radioLine {\r\n                    padding-left: $line-padding-left;\r\n                    height: 30px;\r\n                    display: grid;\r\n                    grid-template-columns: 1fr 24px;\r\n\r\n                    .label {\r\n                        grid-column: 1;\r\n                        display: flex;\r\n                        align-items: center;\r\n                    }\r\n\r\n                    .radioContainer {\r\n                        display: flex;\r\n                        align-items: center;\r\n\r\n                        .radio {\r\n                            grid-column: 2;\r\n                            display: none;\r\n\r\n                            &:checked + label:before {\r\n                                border-color: rgb(51, 122, 183);\r\n                            }\r\n                            &:checked + label:after {\r\n                                transform: scale(1);\r\n                            }\r\n                        }\r\n\r\n                        .labelForRadio {\r\n                            display: inline-block;\r\n                            height: 14px;\r\n                            position: relative;\r\n                            padding: 0 24px;\r\n                            margin-bottom: 0;\r\n                            cursor: pointer;\r\n                            vertical-align: bottom;\r\n                            &:before,\r\n                            &:after {\r\n                                position: absolute;\r\n                                content: \"\";\r\n                                border-radius: 50%;\r\n                                transition: all 0.3s ease;\r\n                                transition-property: transform, border-color;\r\n                            }\r\n                            &:before {\r\n                                left: 0px;\r\n                                top: 0;\r\n                                width: 16px;\r\n                                height: 16px;\r\n                                border: 2px solid white;\r\n                            }\r\n                            &:after {\r\n                                top: 6px;\r\n                                left: 6px;\r\n                                width: 8px;\r\n                                height: 8px;\r\n                                transform: scale(0);\r\n                                background: rgb(51, 122, 183);\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .vector3Line {\r\n                    padding-left: $line-padding-left;\r\n                    display: grid;\r\n\r\n                    .firstLine {\r\n                        display: grid;\r\n                        grid-template-columns: 1fr auto 20px;\r\n                        height: 30px;\r\n\r\n                        .label {\r\n                            grid-column: 1;\r\n                            display: flex;\r\n                            align-items: center;\r\n                            white-space: nowrap;\r\n                            overflow: hidden;\r\n                        }\r\n\r\n                        .vector {\r\n                            grid-column: 2;\r\n                            display: flex;\r\n                            align-items: center;\r\n                            text-align: right;\r\n                            opacity: 0.8;\r\n                            padding-left: 5px;\r\n                        }\r\n\r\n                        .expand {\r\n                            grid-column: 3;\r\n                            display: grid;\r\n                            align-items: center;\r\n                            justify-items: center;\r\n                            cursor: pointer;\r\n                        }\r\n                    }\r\n\r\n                    .secondLine {\r\n                        display: grid;\r\n                        padding-right: 5px;\r\n                        border-left: 1px solid rgb(51, 122, 183);\r\n\r\n                        .numeric {\r\n                            display: grid;\r\n                            grid-template-columns: 1fr auto;\r\n                        }\r\n\r\n                        .numeric-label {\r\n                            text-align: right;\r\n                            grid-column: 1;\r\n                            display: flex;\r\n                            align-items: center;\r\n                            justify-self: right;\r\n                            margin-right: 10px;\r\n                        }\r\n\r\n                        .numeric-value {\r\n                            width: 120px;\r\n                            grid-column: 2;\r\n                            display: flex;\r\n                            align-items: center;\r\n                            border: 1px solid rgb(51, 122, 183);\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .checkBoxLine {\r\n                    padding-left: $line-padding-left;\r\n                    height: 30px;\r\n                    display: grid;\r\n                    grid-template-columns: 1fr auto;\r\n\r\n                    .label {\r\n                        grid-column: 1;\r\n                        display: flex;\r\n                        align-items: center;\r\n                    }\r\n\r\n                    .checkBox {\r\n                        grid-column: 2;\r\n\r\n                        display: flex;\r\n                        align-items: center;\r\n\r\n                        .lbl {\r\n                            position: relative;\r\n                            display: block;\r\n                            height: 14px;\r\n                            width: 34px;\r\n                            margin-right: 5px;\r\n                            background: #898989;\r\n                            border-radius: 100px;\r\n                            cursor: pointer;\r\n                            transition: all 0.3s ease;\r\n\r\n                            &.checked {\r\n                                background: rgb(51, 122, 183);\r\n                            }\r\n                        }\r\n\r\n                        .lbl:after {\r\n                            position: absolute;\r\n                            left: 3px;\r\n                            top: 2px;\r\n                            display: block;\r\n                            width: 10px;\r\n                            height: 10px;\r\n                            border-radius: 100px;\r\n                            background: #fff;\r\n                            box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.05);\r\n                            content: \"\";\r\n                            transition: all 0.15s ease;\r\n\r\n                            &.checked {\r\n                                left: 20px;\r\n                                background: rgb(22, 73, 117);\r\n                            }\r\n                        }\r\n\r\n                        .lbl.checked:after {\r\n                            position: absolute;\r\n                            top: 2px;\r\n                            display: block;\r\n                            width: 10px;\r\n                            height: 10px;\r\n                            border-radius: 100px;\r\n                            background: #fff;\r\n                            box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.05);\r\n                            content: \"\";\r\n                            transition: all 0.15s ease;\r\n                            left: 20px;\r\n                            background: rgb(22, 73, 117);\r\n                        }\r\n\r\n                        .lbl:active:after {\r\n                            transform: scale(1.15, 0.85);\r\n                        }\r\n\r\n                        .hidden {\r\n                            display: none;\r\n                        }\r\n\r\n                        .icon {\r\n                            display: none;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .textureLine {\r\n                    display: grid;\r\n                    grid-template-rows: 30px auto;\r\n\r\n                    .control {\r\n                        margin-top: 2px;\r\n                        grid-row: 1;\r\n                        display: grid;\r\n                        grid-template-columns: 1fr 40px 40px 40px 40px 40px 1fr;\r\n\r\n                        .red {\r\n                            grid-column: 2;\r\n                        }\r\n\r\n                        .green {\r\n                            grid-column: 3;\r\n                        }\r\n\r\n                        .blue {\r\n                            grid-column: 4;\r\n                        }\r\n\r\n                        .alpha {\r\n                            grid-column: 5;\r\n                        }\r\n\r\n                        .all {\r\n                            grid-column: 6;\r\n                        }\r\n                    }\r\n\r\n                    .control3D {\r\n                        margin-top: 2px;\r\n                        grid-row: 1;\r\n                        display: grid;\r\n                        grid-template-columns: 1fr 40px 40px 40px 40px 40px 40px 1fr;\r\n\r\n                        .px {\r\n                            grid-column: 2;\r\n                        }\r\n\r\n                        .nx {\r\n                            grid-column: 3;\r\n                        }\r\n\r\n                        .py {\r\n                            grid-column: 4;\r\n                        }\r\n\r\n                        .ny {\r\n                            grid-column: 5;\r\n                        }\r\n\r\n                        .pz {\r\n                            grid-column: 6;\r\n                        }\r\n\r\n                        .nz {\r\n                            grid-column: 7;\r\n                        }\r\n                    }\r\n\r\n                    .command {\r\n                        border: 1px solid transparent;\r\n                        background: transparent;\r\n                        color: white;\r\n                    }\r\n\r\n                    .selected {\r\n                        border: 1px solid rgb(51, 122, 183);\r\n                    }\r\n\r\n                    .preview {\r\n                        grid-row: 2;\r\n                        display: grid;\r\n                        align-self: center;\r\n                        justify-self: center;\r\n                        height: 256px;\r\n                        width: 256px;\r\n                        margin-top: 5px;\r\n                        margin-bottom: 5px;\r\n                        border: 1px solid white;\r\n                        background-size: 32px 32px;\r\n                        background-color: white;\r\n                        background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2 2'%3E%3Cpath fill='rgba(1.0,1.0,1.0,0.3)' fill-rule='evenodd' d='M0 0h1v1H0V0zm1 1h1v1H1V1z'/%3E%3C/svg%3E\");\r\n                    }\r\n                }\r\n\r\n                .gltf-extension-property {\r\n                    margin-left: 30px;\r\n                    border-left: 1px solid rgb(51, 122, 183);\r\n                }\r\n\r\n                .floatLine {\r\n                    padding-left: $line-padding-left;\r\n                    height: 30px;\r\n                    display: grid;\r\n                    grid-template-columns: 1fr 120px;\r\n\r\n                    .label {\r\n                        grid-column: 1;\r\n                        display: flex;\r\n                        align-items: center;\r\n                    }\r\n\r\n                    .value {\r\n                        grid-column: 2;\r\n\r\n                        display: flex;\r\n                        align-items: center;\r\n\r\n                        input {\r\n                            width: 110px;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .sliderLine {\r\n                    padding-left: $line-padding-left;\r\n                    height: 30px;\r\n                    display: grid;\r\n                    grid-template-rows: 100%;\r\n                    grid-template-columns: 1fr 50px auto;\r\n\r\n                    .label {\r\n                        grid-column: 1;\r\n                        display: flex;\r\n                        align-items: center;\r\n                    }\r\n\r\n                    .withMargins {\r\n                        margin-left: 5px;\r\n                    }\r\n\r\n                    .floatLine {\r\n                        padding-left: $line-padding-left;\r\n\r\n                        .short {\r\n                            grid-column: 1;\r\n                            display: flex;\r\n                            align-items: center;\r\n\r\n                            input {\r\n                                width: 35px;\r\n                            }\r\n\r\n                            input::-webkit-outer-spin-button,\r\n                            input::-webkit-inner-spin-button {\r\n                                -webkit-appearance: none;\r\n                                margin: 0;\r\n                            }\r\n\r\n                            input[type=\"number\"] {\r\n                                -moz-appearance: textfield;\r\n                            }\r\n                        }\r\n                    }\r\n\r\n                    .slider {\r\n                        grid-column: 3;\r\n                        grid-row: 1;\r\n                        margin-right: 5px;\r\n                        width: 90%;\r\n                        display: flex;\r\n                        align-items: center;\r\n\r\n                        .range {\r\n                            -webkit-appearance: none;\r\n                            width: 100%;\r\n                            height: 6px;\r\n                            background: #d3d3d3;\r\n                            border-radius: 5px;\r\n                            outline: none;\r\n                            opacity: 0.7;\r\n                            -webkit-transition: 0.2s;\r\n                            transition: opacity 0.2s;\r\n                        }\r\n\r\n                        .range:hover {\r\n                            opacity: 1;\r\n                        }\r\n\r\n                        .range::-webkit-slider-thumb {\r\n                            -webkit-appearance: none;\r\n                            appearance: none;\r\n                            width: 14px;\r\n                            height: 14px;\r\n                            border-radius: 50%;\r\n                            background: rgb(51, 122, 183);\r\n                            cursor: pointer;\r\n                        }\r\n\r\n                        .range::-moz-range-thumb {\r\n                            width: 14px;\r\n                            height: 14px;\r\n                            border-radius: 50%;\r\n                            background: rgb(51, 122, 183);\r\n                            cursor: pointer;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .color3Line {\r\n                    padding-left: $line-padding-left;\r\n                    display: grid;\r\n\r\n                    .firstLine {\r\n                        height: 30px;\r\n                        display: grid;\r\n                        grid-template-columns: 1fr auto 20px 20px;\r\n\r\n                        .label {\r\n                            grid-column: 1;\r\n                            display: flex;\r\n                            align-items: center;\r\n                        }\r\n\r\n                        .color3 {\r\n                            grid-column: 2;\r\n                            width: 50px;\r\n\r\n                            display: flex;\r\n                            align-items: center;\r\n\r\n                            input[type=\"color\"] {\r\n                                -webkit-appearance: none;\r\n                                border: 1px solid rgba(255, 255, 255, 0.5);\r\n                                padding: 0;\r\n                                width: 30px;\r\n                                height: 20px;\r\n                            }\r\n                            input[type=\"color\"]::-webkit-color-swatch-wrapper {\r\n                                padding: 0;\r\n                            }\r\n                            input[type=\"color\"]::-webkit-color-swatch {\r\n                                border: none;\r\n                            }\r\n\r\n                            input {\r\n                                margin-right: 5px;\r\n                            }\r\n                        }\r\n\r\n                        .copy {\r\n                            grid-column: 3;\r\n                            display: grid;\r\n                            align-items: center;\r\n                            justify-items: center;\r\n                            cursor: pointer;\r\n                            img {\r\n                                height: 100%;\r\n                            }\r\n                        }\r\n\r\n                        .expand {\r\n                            grid-column: 4;\r\n                            display: grid;\r\n                            align-items: center;\r\n                            justify-items: center;\r\n                            cursor: pointer;\r\n                        }\r\n                    }\r\n\r\n                    .secondLine {\r\n                        display: grid;\r\n                        padding-right: 5px;\r\n                        border-left: 1px solid rgb(51, 122, 183);\r\n\r\n                        .numeric {\r\n                            display: grid;\r\n                            grid-template-columns: 1fr auto;\r\n                        }\r\n\r\n                        .numeric-label {\r\n                            text-align: right;\r\n                            grid-column: 1;\r\n                            display: flex;\r\n                            align-items: center;\r\n                            justify-self: right;\r\n                            margin-right: 10px;\r\n                        }\r\n\r\n                        .numeric-value {\r\n                            width: 120px;\r\n                            grid-column: 2;\r\n                            display: flex;\r\n                            align-items: center;\r\n                            border: 1px solid rgb(51, 122, 183);\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .listLine {\r\n                    padding-left: $line-padding-left;\r\n                    height: 30px;\r\n                    display: grid;\r\n                    grid-template-columns: 1fr auto;\r\n\r\n                    .label {\r\n                        grid-column: 1;\r\n                        display: flex;\r\n                        align-items: center;\r\n                    }\r\n\r\n                    .options {\r\n                        grid-column: 2;\r\n\r\n                        display: flex;\r\n                        align-items: center;\r\n                        margin-right: 5px;\r\n\r\n                        select {\r\n                            width: 115px;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .paneContainer {\r\n                    margin-top: 3px;\r\n                    display: grid;\r\n                    grid-template-rows: 100%;\r\n                    grid-template-columns: 100%;\r\n\r\n                    .paneList {\r\n                        border-left: 3px solid transparent;\r\n                    }\r\n\r\n                    &:hover {\r\n                        .paneList {\r\n                            border-left: 3px solid rgba(51, 122, 183, 0.8);\r\n                        }\r\n\r\n                        .paneContainer-content {\r\n                            .header {\r\n                                .title {\r\n                                    border-left: 3px solid rgb(51, 122, 183);\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n\r\n                    .paneContainer-highlight-border {\r\n                        grid-row: 1;\r\n                        grid-column: 1;\r\n                        opacity: 1;\r\n                        border: 3px solid red;\r\n                        margin-bottom: -5px;\r\n                        z-index: 100;\r\n                        transition: opacity 250ms;\r\n                        pointer-events: none;\r\n\r\n                        &.transparent {\r\n                            opacity: 0;\r\n                        }\r\n                    }\r\n\r\n                    .paneContainer-content {\r\n                        grid-row: 1;\r\n                        grid-column: 1;\r\n\r\n                        .header {\r\n                            display: grid;\r\n                            grid-template-columns: 1fr auto;\r\n                            background: #555555;\r\n                            height: 30px;\r\n                            padding-right: 5px;\r\n                            cursor: pointer;\r\n\r\n                            .title {\r\n                                border-left: 3px solid transparent;\r\n                                padding-left: 5px;\r\n                                grid-column: 1;\r\n                                display: flex;\r\n                                align-items: center;\r\n                            }\r\n\r\n                            .collapse {\r\n                                grid-column: 2;\r\n                                display: flex;\r\n                                align-items: center;\r\n                                justify-items: center;\r\n                                transform-origin: center;\r\n\r\n                                &.closed {\r\n                                    transform: rotate(180deg);\r\n                                }\r\n                            }\r\n                        }\r\n\r\n                        .paneList > div:not(:last-child) {\r\n                            border-bottom: 0.5px solid rgba(255, 255, 255, 0.1);\r\n                        }\r\n\r\n                        .fragment > div:not(:last-child) {\r\n                            border-bottom: 0.5px solid rgba(255, 255, 255, 0.1);\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
